export default __webpack_public_path__ + "static/media/ai-credits.b18da9b1.svg";